import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles
} from '@material-ui/core'
import NoRecordImg from '../../images/norecord.png'

const useStyles = makeStyles(theme => ({
  fileImage: {
    height: '90%',
    width: '100%',
    justifyContent: 'center',
    display: 'flex'
  },
  img: {
    maxHeight: '100%',
    maxWidth: '100%'
  },
  loader: {
    position: 'absolute',
    top: '45%',
    left: '45%',
    color: '#333'
  },
  downloadButton: {
    marginTop: theme.spacing(2),
    textAlign: 'center'
  }
}))

export default function ViewLabRecordModal({ open, handleClose, record }) {
  const classes = useStyles()
  const [viewerUrl, setViewerUrl] = React.useState(null)

  React.useEffect(() => {
    if (!record) return

    const url = new URL(record.toLowerCase())
    const path = url.pathname

    if (
      path.endsWith('.pdf') ||
      path.endsWith('.doc') ||
      path.endsWith('.docx') ||
      path.endsWith('.xls') ||
      path.endsWith('.xlsx')
    ) {
      const documentUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
        record
      )}`
      setViewerUrl(documentUrl)
    } else {
      setViewerUrl(null)
    }
  }, [record])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        Preview Document
        <span className={classes.cross} onClick={handleClose}>
          Close
        </span>
      </DialogTitle>
      <DialogContent>
        {record ? (
          <div className={classes.fileImage}>
            {viewerUrl ? (
              <a href={viewerUrl} target="_blank" rel="noopener noreferrer">
                <u>Click to View Pdf/Document file</u>
              </a>
            ) : (
              <img className={classes.img} src={record} alt="Preview" />
            )}
          </div>
        ) : (
          <img
            src={NoRecordImg}
            className={classes.notFoundImage}
            alt="Not found!"
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
